import {
    BANNER_DEPENDS_ON_AB_TEST_STATES,
    BANNER_DEPENDS_ON_BONUS_STATES,
    BANNER_DEPENDS_ON_PARAMS
} from "../bannersConstants";
import parseAccountName from "../../../utils/parseAccountName";
import { ACCOUNT_TYPES } from "../../../app/appConstants";
import { IAbTest, IAbTests, IFeatures } from "../../../app/types/appActions.t";
import _ from "lodash";
import { IBanner } from "../banners.t";
import { IBonusesActiveList, IBonusesAvailableList, IPromocodesList } from "../../Bonus/types/bonusesActions";

interface IFilterBannerByDependsOnProps {
    abTests: IAbTests,
    activePromocodesList: IPromocodesList,
    banner: IBanner,
    bonusesActiveList: IBonusesActiveList,
    bonusesAvailableList: IBonusesAvailableList,
    features: IFeatures,
}

function filterBannerByDependsOn(props: IFilterBannerByDependsOnProps) {
    const {
        abTests,
        activePromocodesList,
        banner,
        bonusesActiveList,
        bonusesAvailableList,
        features,
    } = props;
    return !banner.depends_on?.length || banner.depends_on.every(dependsOn => {
        switch (dependsOn.param) {
            case BANNER_DEPENDS_ON_PARAMS.FEATURE:
                return features[dependsOn.value];
            case BANNER_DEPENDS_ON_PARAMS.BONUS:
                const activeBonus = bonusesActiveList.find(bonus => bonus.name === dependsOn.value && parseAccountName(bonus.account)?.type === ACCOUNT_TYPES.LIVE);
                const availableBonus = bonusesAvailableList.find(bonus => bonus.bonus_name === dependsOn.value && parseAccountName(bonus.account)?.type === ACCOUNT_TYPES.LIVE);
                if (dependsOn.state === BANNER_DEPENDS_ON_BONUS_STATES.ACTIVE) {
                    return !!activeBonus;
                } else if (dependsOn.state === BANNER_DEPENDS_ON_BONUS_STATES.AVAILABLE) {
                    return !!availableBonus;
                } else if (dependsOn.state === BANNER_DEPENDS_ON_BONUS_STATES.ACTIVE_OR_AVAILABLE) {
                    return !!activeBonus || !!availableBonus;
                }
                return true;
            case BANNER_DEPENDS_ON_PARAMS.AB_TEST:
                const checkAbTest: IAbTest = abTests?.[dependsOn.value];
                if (!checkAbTest) return false;
                return dependsOn.state === BANNER_DEPENDS_ON_AB_TEST_STATES.SHOW
                    ? checkAbTest.option === dependsOn.option
                    : checkAbTest.option !== dependsOn.option;
            case BANNER_DEPENDS_ON_PARAMS.PROMOCODE:
                const activePromocode = _.find(activePromocodesList, { promocode: dependsOn.value });
                return dependsOn.state === BANNER_DEPENDS_ON_BONUS_STATES.ACTIVE && !!activePromocode;
            default:
                return true;
        }
    })
}

export default filterBannerByDependsOn;
